import React, { useCallback, useContext } from 'react'
import TestTakerHeader from 'pages/School/TestTakers/TestTakerHeader'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { Title } from 'components'
import { useLocation, useNavigate } from 'react-router-dom';
import { app, practiceAssessments } from './routes';
import { alerts as alertsKeys } from 'keys'
import { useAlert } from 'components/Alerts/hooks';
import { AbilityContext } from 'components/Permissions/Can';
import AssessmentDetails from 'pages/School/Assessment/AssessmentDetails'
import { Alert } from '@mui/material'
import { systemTypes } from 'keys/systems'
import { AssessmentUploadNotifications } from 'pages/School/PerformAssessment'

const WrapAppRoute = (props) => {
    const { hideAlerts, system, isGeneralPage, exitAlert, feature, children, hideHeader, title, featurePath, breadcrumbs } = props

    const { pathname } = useLocation()
    const { assessment, isInAssessmentMode, uploadingAssessmentIds, stuckAssessmentIds } = useSelector(state => state.assessment)
    const { alerts } = useSelector(state => state.general)
    const { setAlerts } = useAlert()
    const navigate = useNavigate()
    const ability = useContext(AbilityContext)

    const childrenWithProps = () => {
        return React.Children.map(children, child => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    ...props,
                })
            }
            return child
        })
    }

    const closeExitScreenAlert = useCallback(() => {
        setAlerts(alertsKeys.exitScreen, false)
    }, [])

    // צריך להעביר את זה למקום אחר זה רלוונטי רק ליציאה מביצוע מבדק ולא קשור למקום כללי כמו פה
    const acceptExitScreenAlert = useCallback(() => {
        closeExitScreenAlert()
        if (ability.can("read", "perform-assessments")) {
            const section = pathname.match(/^\/([^/]+)/)?.[1];
            if (section == practiceAssessments)
                navigate(app.practiceAssessments)
            else navigate(app.performAssessments)

        }
        else navigate(app.dashboard)
    }, [pathname])

    const showUploadBlockAlert = system == systemTypes.school && !hideAlerts

    return (
        <>
            {exitAlert && alerts[alertsKeys.exitScreen].open && <props.exitAlert close={closeExitScreenAlert} accept={acceptExitScreenAlert} />}
            {showUploadBlockAlert &&
                <AssessmentUploadNotifications
                    isInAssessmentMode={isInAssessmentMode}
                    uploadingAssessmentIds={uploadingAssessmentIds}
                    stuckAssessmentIds={stuckAssessmentIds}
                />}
            {(title && !breadcrumbs) && <Title feature={feature} title={title} featurePath={featurePath} />}
            {!isGeneralPage && !hideHeader && !breadcrumbs &&
                <>
                    {isEmpty(assessment) ?
                        <TestTakerHeader /> :
                        <AssessmentDetails />
                    }
                </>
            }
            {childrenWithProps()}
        </>
    )

}

export default WrapAppRoute